import { useAuth } from '@/store/useAuth';
import { useUpdateUserData } from '@/hooks/use-update-profile';
import { generatePath, useNavigate } from 'react-router';
import { routesApp } from '@/constans/routes';
import React, { useCallback, useEffect } from 'react';
import { UploadPhotoRegistartionForm } from './components/upload-photo-registartion-form';
import 'react-toastify/dist/ReactToastify.css';
import { NameRegistartionForm } from './components/name-registartion-form';
import { TargetInfoRegistrationForm } from '@/components/form-registration-v4/components/target-info-registartion-form';
import { AboutAndTravelPlansRegistartionForm } from './components/about-and-travel-plans-registartion-form';
import { callYaMetrika } from '@/utils/call-ya-metrika';
import { eventsApi } from '@/api';
import { DateAndGenderRegistartionForm } from './components/date-and-gender-registartion-form';
import { DirectionInfoRegistrationForm } from '../form-registration-v4/components/direction-info-registartion-form';
import { useUpdateUserDataWithoutRefetch } from '@/hooks/use-update-profile-without-refetch';
import { useTranslation } from 'react-i18next';
interface Props {
    step?: string;
    isLoadingOncePage?: boolean;
    onChangeIsLoadingPage?: (bol: boolean) => void;
}

export const FormRegistration: React.FC<Props> = ({ step, isLoadingOncePage, onChangeIsLoadingPage }) => {
    const userData = useAuth((state) => state.getUser());
    const { mutateAsync: updateUserData } = useUpdateUserData();
    const { mutateAsync: updateUserDataWithoutRefetch } = useUpdateUserDataWithoutRefetch();
    const handleUpdateUserData = async (data: any) => {
        if (!userData) return;
        await updateUserData(data);
    };

    const handleUpdateUserDataWithoutRefetch = async (data: any) => {
        if (!userData) return;
        await updateUserDataWithoutRefetch(data);
    };

    const navigateToNextStep = useNavigate();
    const nextStep = useCallback(
        (step: string) =>
            navigateToNextStep(
                generatePath(
                    routesApp.registrationV4,
                    { stepNumer: step }
                )
            ),
        [navigateToNextStep],
    );
    useEffect(() => {
        if (userData && isLoadingOncePage) {
            onChangeIsLoadingPage?.(false);
            // Если пользователь уже отмечен как завершенный - не душим его повторным проходом по регистрации
            // кидаем сразу в ленту
            if (userData.state === 'complete') {
                navigateToNextStep(generatePath(routesApp.browse));
                return;
            }
            // Проверяем, на каком шаге нужно продолжить регистрацию
            if (!userData?.public_name) {
                nextStep('1');
                return;
            }
            // Если первый этап заполнен, но ссылка всё равно ведёт на него - переходим
            if (step && step === '1') {
                nextStep(step);
                return;
            }
            // Если первый и второй этап заполнены, но ссылка всё равно ведёт на них - переходим
            if (step && ['1', '2'].includes(step)) {
                nextStep(step);
                return;
            }
            if (step && ['1', '2', '3'].includes(step)) {
                nextStep(step);
                return;
            }
            // Если первый, второй, третий и четвертый этап заполнены, но ссылка всё равно ведёт на них - переходим
            if (step && ['1', '2', '3', '4'].includes(step)) {
                nextStep(step);
                return;
            }
            // Если первый, второй, третий, четвертый и пятый этап заполнены, но ссылка всё равно ведёт на них - переходим
            if (step && ['1', '2', '3', '4', '5'].includes(step)) {
                nextStep(step);
                return;
            }
            nextStep('6');
        }
    }, []);

    const { t } = useTranslation();

    switch (step) {
        case '1':
            return (
                <NameRegistartionForm
                    userData={userData}
                    onUpdateUserData={handleUpdateUserData}
                    nextStep={() => nextStep('2')} />
            );
        case '2':
            return (
                <DateAndGenderRegistartionForm
                    userData={userData}
                    onUpdateUserData={handleUpdateUserData}
                    nextStep={() => nextStep('3')} />
            );
        case '3':
            return (
                <UploadPhotoRegistartionForm userData={userData} />
            );
        case '4':
            return (
                <AboutAndTravelPlansRegistartionForm
                    userData={userData}
                    onUpdateUserData={handleUpdateUserData}
                    nextStep={() => nextStep('5')} />
            );
        case '5':
            return (
                <DirectionInfoRegistrationForm
                    userData={userData}
                    onUpdateUserData={handleUpdateUserData}
                    nextStep={() => nextStep('6')} />
            );
        case '6':
            return (
                <TargetInfoRegistrationForm
                    userData={userData}
                    onUpdateUserData={handleUpdateUserDataWithoutRefetch}
                    nextStep={() => {
                        callYaMetrika('complete_registration4');
                        eventsApi.updateUserEvent('complete_registration4');
                        navigateToNextStep(routesApp.browse)
                    }} />
            );
        default:
            return <>{t('registration.error404')}</>;
    }
};
